import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "designing-a-plugin-experience"
    }}>{`Designing a plugin experience`}</h1>
    <p>{`These guidelines will help you define the best user experience for your plugin. As you create a plugin, consider different UX patterns and UI components based on your user’s workflow and the plugin action.`}</p>
    <p>{` Plugins can interact with a user’s experience at different levels, for example, some plugins in some use cases won’t render an interface, and some will include actions that need an interface.`}</p>
    <h2 {...{
      "id": "designing-a-plugin"
    }}>{`Designing a plugin`}</h2>
    <p><strong parentName="p">{`Learn more about the types interfaces available to plugins.`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Plugins panel`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Plugins dialog`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`non-blocking UI:`}</strong>{` This interface is best used when the user should have access to the canvas while using the plugin.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`blocking UI:`}</strong>{` This interface is best used when the plugin needs to run an action and the user shouldn’t modify or change selection of objects on the canvas.`}</td>
        </tr>
      </tbody>
    </table>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "80%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/cb523/Panel_Dialog_examples.webp 320w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/797b9/Panel_Dialog_examples.webp 640w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/4b075/Panel_Dialog_examples.webp 1280w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/f3ff0/Panel_Dialog_examples.webp 1920w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/09431/Panel_Dialog_examples.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/72799/Panel_Dialog_examples.png 320w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/6af66/Panel_Dialog_examples.png 640w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/21b4d/Panel_Dialog_examples.png 1280w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/29114/Panel_Dialog_examples.png 1920w", "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/20a65/Panel_Dialog_examples.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/6ab3a74dfc3795f30c63e740d914da47/21b4d/Panel_Dialog_examples.png",
            "alt": "Examples showing the plugins panel interface and the plugins dialog interface",
            "title": "Examples showing the plugins panel interface and the plugins dialog interface",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "ux-patterns"
    }}>{`UX patterns`}</h2>
    <p>{`User experience patterns highlight UX requirements and best practices, as well as provide guidance on how to interact with your plugin users within Adobe.`}</p>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/design/ux-patterns/"
      }}>{`View UX patterns`}</a></p>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/design/ux-patterns/Designingforphotoshop/"
      }}>{`Designing for photoshop`}</a></p>
    <h2 {...{
      "id": "user-interface"
    }}>{`User interface`}</h2>
    <p>{`The user interface section will have information on UXP Spectrum components you can use to build your plugin interface. `}</p>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/design/user-interface/"
      }}>{`View user interface components`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      